<div class="home-container">
  <app-breadcrumb breadcrumb="/ Imperia"></app-breadcrumb>
  <div fxLayout="row" class="home-container__section">
    <app-section-title
      [optionName]="'WELCOME TO YOUR'"
      [pageName]="'IMPERIA PORTAL'"
    ></app-section-title>
  </div>
  <div fxLayout="row" fxLayoutGap="5pt">
    <ng-container
      *ngIf="
        externalSystems && externalSystems.length > 0 && !isLoading;
        else noExternalSystems
      "
    >
      <div fxLayout="row wrap" fxLayoutGap="5pt" class="useful-links">
        <div class="useful-links__item" *ngFor="let ulink of externalSystems">
          <form
            method="GET"
            action="{{ ulink.linkUrl }}"
            target="_blank"
            ngNoForm
            *ngIf="ulink.code === 'SC'"
          >
            <input type="hidden" name="txtUserName" [value]="ulink.id" />
            <input
              type="hidden"
              name="hiddenSignature"
              [value]="ulink.password"
            />
            <button type="submit" value="submit" class="cb linksContainer">
              <div
                class="image"
                [class]="ulink.code ? ulink.code : 'undefined'"
              ></div>
              <div class="description">
                <span class="suite-claims-title">{{
                  ulink.linkDescription
                }}</span>
              </div>
            </button>
          </form>
          <a
            *ngIf="
              ulink.code !== 'SC' && ulink.code !== 'LA'
            "
            class="linksContainer"
            [href]="
              ulink.code === 'LBI'
                ? ulink.linkUrl
                : externalSystemUrl(
                    ulink.linkUrl,
                    ulink.id,
                    ulink.password,
                    ulink.code
                  )
            "
            target="_blank"
            [attr.aria-label]="ulink.linkDescription + ' - ' + ulink.code"
          >
            <div
              class="image"
              [class]="ulink.code ? ulink.code : 'undefined'"
            ></div>
            <div class="description">
              <span
                ><b>{{ ulink.linkDescription }}</b></span
              >
            </div>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- No External Systems found card content -->
  <ng-template #noExternalSystems>
    <div class="no-external-systems">
      <span>No external systems found</span>
    </div>
  </ng-template>
</div>
<div fxLayout="row" fxLayoutAlign="center center" *ngIf="isLoading">
  <app-loading [isRelative]="true"></app-loading>
</div>
